import Model, { type AsyncBelongsTo, attr, belongsTo } from '@ember-data/model';
import type FlowModel from 'garaje/models/flow';
import type LocationModel from 'garaje/models/location';

export default class HostSignOutReminderConfigurationModel extends Model {
  @attr('number') declare reminderDurationMinutes: number;
  @attr('boolean', { defaultValue: true }) declare enabled: boolean;
  @attr('boolean', { defaultValue: true }) declare pushEnabled: boolean;
  @attr('boolean', { defaultValue: true }) declare emailEnabled: boolean;

  @belongsTo('location', { async: true, inverse: null }) declare location: AsyncBelongsTo<LocationModel>;
  @belongsTo('flow', { async: true, inverse: null }) declare flow: AsyncBelongsTo<FlowModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'host-sign-out-reminder-configuration': HostSignOutReminderConfigurationModel;
  }
}
